import React from "react";
import { Routes, Route } from "react-router-dom";

import Dashboard from "../pages/Dashboard";
import DadosComplementares from "../pages/DadosComplementares";
import Beneficiarios from "../pages/Beneficiarios";
import DadosBancarios from "../pages/DadosBancarios";
import Adesao from "../pages/Adesao";
import AdesaoFiles from "../pages/AdesaoFiles";

const AppRoutes: React.FC = () => (
  <Routes>
    <Route path="/" element={<Dashboard />} />
    <Route path="/dados-complementares" element={<DadosComplementares />} />
    <Route path="/beneficiarios" element={<Beneficiarios />} />
    <Route path="/dados-bancarios" element={<DadosBancarios />} />
    <Route path="/adesao/files/:idSolic" element={<AdesaoFiles />} />
    <Route path="/adesao" element={<Adesao />} />
  </Routes>
);

export default AppRoutes;
